export default function () {
  return {
    fundsCategories: {},
    loading: false,
  }
}
